export default "__VITE_ASSET__Dr2X0Sql__"